import { Container, Navbar, Dropdown } from "react-bootstrap";
import Logo from "../../assets/images/skyspeak-logo.svg";
import avtar from "../../assets/images/user.png";
import { GoChevronDown } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
const Header = () => {
  const {
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [image, setImage] = useState<string>(avtar);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const navigate = useNavigate();
  useEffect(() => {
    getUserData();
  }, []);
  const getUserData = () => {
    // setLoading(true);
    WebService.getAPI({
      action: `/users/me`,
      body: null,
    })
      .then((res: any) => {
        console.log("User Data Response:", res.result);
        setLoading(false);
        setUserData(res.result);
        setValue("name", res.result.name);
        setValue("email", res.result.email);
        setValue("mobile", res.result.mobile);
        setImage(res.result.image || null);
      })
      .catch((e) => {
        setLoading(false);
        toast.error("Failed to fetch user data.");
      });
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    document.body.classList.toggle("show-mo-menu");
    setMenuOpen((prev) => !prev);
  };

  const handleMenuClose = () => {
    document.body.classList.remove("show-mo-menu");
    setMenuOpen(false);
  };

  const LogOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserData");
    localStorage.removeItem("userId");
    navigate("/login");
  };
  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg" className="w-100 d-flex align-items-center">
            {/* Brand / Logo */}
            <Navbar.Brand className="me-3">
              <img src={Logo} height={80} alt="SkySpeak logo" />
            </Navbar.Brand>

            {/* Push everything else to the right */}
            <div className="d-flex align-items-center ms-auto gap-3">
              {/* Toggle (hamburger) positioned at right now */}
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={handleMenuToggle}
                className="border-0 shadow-none d-flex align-items-center d-block d-sm-none"
              />

              {/* Profile Dropdown */}
              <Dropdown className="profile-dd">
                <Dropdown.Toggle className="d-flex align-items-center bg-transparent border-0 shadow-none">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      src={image || avtar}
                      width={35}
                      height={35}
                      className="rounded-circle object-fit-cover"
                      alt="profile"
                    />
                    <div className="d-none d-sm-block">
                      <p className="font-14 mb-0 text-dark fw-medium">
                        {userData.name}
                      </p>
                      <p className="font-12 mb-0 text-secondary">
                        {userData.email}
                      </p>
                    </div>
                  </div>
                  <GoChevronDown size={16} className="icon ms-1" />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                  {userData?.type === "USER" && (
                    <Dropdown.Item href="/contactus">Contact Us</Dropdown.Item>
                  )}
                  <Dropdown.Item onClick={LogOut}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar>
        </Container>
      </header>
    </>
  );
};
export default Header;
